/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useState } from "react";
import { AutoAwesomeOutlined } from "@mui/icons-material";
import Fab from "@mui/material/Fab";
import { Box, SxProps } from "@mui/material";
import AiWizardModal, { AiWizardModalProps } from "./AiWizardModal";

import { ProductUnion } from "../../../../types/ProductUnion";

export type AiWizardProps = {
  product: ProductUnion;
  sx?: SxProps;
  defaultScopeKey?: string;
  promptContext?: Record<string, any>;
} & Pick<AiWizardModalProps, "componentScopes">;

export default function AiWizard({
  product,
  sx = {},
  componentScopes,
  defaultScopeKey = "customPdf",
  promptContext = {},
}: AiWizardProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [isRefinement, setIsRefinement] = useState(false);
  const [generatedText, setGeneratedText] = useState("");

  return (
    <>
      <Box sx={sx}>
        <Fab
          value={"Text mit AI erstellen"}
          onClick={() => setModalOpen(true)}
          color={"primary"}
          sx={{ width: 40, height: 40 }}
        >
          <AutoAwesomeOutlined />
        </Fab>
      </Box>
      <AiWizardModal
        product={product}
        componentScopes={componentScopes}
        isRefinement={isRefinement}
        setIsRefinement={setIsRefinement}
        generatedText={generatedText}
        setGeneratedText={setGeneratedText}
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        defaultScopeKey={defaultScopeKey}
        promptContext={promptContext}
      />
    </>
  );
}
